import { render } from "./LandingView.vue?vue&type=template&id=03821ad9&scoped=true&ts=true"
import script from "./LandingView.vue?vue&type=script&lang=ts"
export * from "./LandingView.vue?vue&type=script&lang=ts"

import "./LandingView.scss?vue&type=style&index=0&id=03821ad9&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03821ad9"]])

export default __exports__